import ApiCore from './utilities/core'
import apiProvider from './utilities/provider'

const url = 'hms'

const apiHMSVideoControl = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  delete: false,
  url,
})

apiHMSVideoControl.createRoom = (interviewVersionId) =>
  apiProvider.post(`${url}/create-room`, interviewVersionId)

apiHMSVideoControl.startRecording = (questionId, roomId, interviewVersionId) =>
  apiProvider.post(`${url}/recording/start`, {
    questionNo: questionId,
    roomId: roomId,
    interviewVersionId: interviewVersionId,
  })

apiHMSVideoControl.pauseRecording = (roomId) =>
  apiProvider.post(`${url}/recording/pause`, {
    roomId: roomId,
  })
apiHMSVideoControl.resumeRecording = (roomId) =>
  apiProvider.post(`${url}/recording/resume`, {
    roomId: roomId,
  })

apiHMSVideoControl.stopRecording = (roomId, interviewVersionId) =>
  apiProvider.post(`${url}/recording/stop`, {
    roomId: roomId,
    interviewVersionId,
  })

export default apiHMSVideoControl
